import { useEffect, useState } from 'react';
import books from '@/assets/images/icons/books.svg';
import warning from '@/assets/images/icons/warning.svg';
import check from '@/assets/images/icons/white_check_mark.svg';
import siren from '@/assets/images/icons/rotating_light.svg';

const ranges = [
  {
    title: 'Matemática',
    levels: [
      {
        bgColor: 'bg-[#FF563014]',
        level: 'Crítico',
        measures: [
          {
            area: 'Rede (Secretaria de Educação)',
            description:
              'Mapear as escolas com menor proficiência em Matemática e priorizar alocação de recursos pedagógicos. Mobilizar equipe técnica para diagnóstico presencial nas unidades em situação crítica. Lançar programa emergencial de reforço com carga horária ampliada. Monitorar semanalmente a evolução dos indicadores.'
          },
          {
            area: 'GRE (Gerência Regional)',
            description:
              'Convocar coordenadores das escolas da regional para alinhamento urgente sobre os dados de desempenho. Redistribuir apoio técnico pedagógico priorizando as escolas com maior defasagem. Acompanhar a execução das monitorias e registrar adesão dos alunos. Reportar à Secretaria com frequência quinzenal.'
          },
          {
            area: 'Unidade Escolar',
            description:
              'Identificar os alunos com maior defasagem e formar grupos de reforço com encontros regulares. Articular com os professores da área para revisão dos conteúdos de maior índice de erro. Acionar famílias dos alunos em situação crítica. Registrar e monitorar a evolução individualmente.'
          }
        ]
      },
      {
        bgColor: 'bg-[#FFAB0014]',
        level: 'Moderado',
        measures: [
          {
            area: 'Rede (Secretaria de Educação)',
            description:
              'Analisar os conteúdos com maior recorrência de erros na rede e orientar as regionais a priorizá-los. Disponibilizar materiais de apoio e sugestões de atividades para os professores. Incluir Matemática como pauta prioritária nas reuniões de acompanhamento pedagógico com as GREs.'
          },
          {
            area: 'GRE (Gerência Regional)',
            description:
              'Compartilhar com as escolas os dados comparativos da regional para estimular a reflexão coletiva. Apoiar a organização de encontros entre professores de Matemática das escolas para troca de práticas. Verificar se as escolas estão utilizando os recursos disponibilizados pela Secretaria.'
          },
          {
            area: 'Unidade Escolar',
            description:
              'Revisar o planejamento pedagógico dos professores de Matemática à luz dos dados de desempenho. Propor atividades de revisão para os conteúdos com maior taxa de erro nos quizzes. Estimular a participação dos alunos nas atividades ativas como desafios e duelos para consolidar aprendizado.'
          }
        ]
      },
      {
        bgColor: 'bg-[#22C55E14]',
        level: 'Preventivo',
        measures: [
          {
            area: 'Rede (Secretaria de Educação)',
            description: 'Manter o monitoramento contínuo dos indicadores de Matemática mesmo nas escolas dentro da meta. Identificar e documentar boas práticas das escolas de melhor desempenho para disseminação na rede.'
          },
          {
            area: 'GRE (Gerência Regional)',
            description: 'Promover visitas de troca entre escolas da regional com bom e médio desempenho em Matemática. Estimular que coordenadores registrem e compartilhem práticas pedagógicas eficazes.'
          },
          {
            area: 'Unidade Escolar',
            description: 'Manter a regularidade das atividades de reforço e acompanhamento mesmo com indicadores estáveis. Valorizar e reconhecer os alunos com evolução positiva para sustentar a motivação.'
          }
        ]
      }
    ]
  },
  {
    title: 'Ciências da Natureza',
    levels: [
      {
        bgColor: 'bg-[#FF563014]',
        level: 'Crítico',
        measures: [
          {
            area: 'Rede (Secretaria de Educação)',
            description:
              'Identificar os conteúdos de Ciências da Natureza com maior defasagem na rede e emitir orientação pedagógica direcionada. Mobilizar suporte técnico para as regionais com maior concentração de escolas críticas. Avaliar se há necessidade de formação emergencial para professores da área.'
          },
          {
            area: 'GRE (Gerência Regional)',
            description:
              'Reunir coordenadores das escolas para análise conjunta dos dados e definição de prioridades. Apoiar as unidades escolares na reorganização do planejamento pedagógico para cobrir os conteúdos críticos. Garantir que as escolas em situação crítica recebam acompanhamento técnico frequente.'
          },
          {
            area: 'Unidade Escolar',
            description:
              'Mapear os conteúdos com maior índice de erro e reorganizar o planejamento para reforçá-los. Criar momentos de revisão coletiva em sala e estimular dúvidas no fórum da plataforma. Acionar monitoria específica para os alunos com pior desempenho na área.'
          }
        ]
      },
      {
        bgColor: 'bg-[#FFAB0014]',
        level: 'Moderado',
        measures: [
          {
            area: 'Rede (Secretaria de Educação)',
            description:
              'Orientar as regionais a acompanhar as escolas com desempenho abaixo da meta e verificar a utilização dos recursos pedagógicos disponíveis. Incluir Ciências da Natureza nas pautas de análise de dados nas reuniões de acompanhamento.'
          },
          {
            area: 'GRE (Gerência Regional)',
            description: 'Apoiar as escolas na identificação dos pontos de maior dificuldade e sugerir estratégias de revisão. Verificar se professores da área estão utilizando as ferramentas da plataforma de forma regular.'
          },
          {
            area: 'Unidade Escolar',
            description:
              'Estimular os alunos a utilizarem as aulas gravadas e o guia de estudos para revisão dos conteúdos com maior taxa de erro. Propor atividades práticas e contextualizadas que facilitem a compreensão dos conteúdos mais abstratos.'
          }
        ]
      },
      {
        bgColor: 'bg-[#22C55E14]',
        level: 'Preventivo',
        measures: [
          {
            area: 'Rede (Secretaria de Educação)',
            description: 'Documentar as estratégias pedagógicas das escolas com bom desempenho em Ciências da Natureza e compartilhar com a rede como referência.'
          },
          {
            area: 'GRE (Gerência Regional)',
            description: 'Estimular encontros entre professores de Ciências da Natureza das escolas da regional para troca de experiências e alinhamento de práticas.'
          },
          {
            area: 'Unidade Escolar',
            description: 'Manter o uso regular da plataforma e os ciclos de quiz e revisão mesmo com desempenho estável. Incentivar a participação dos alunos no fórum como espaço de aprendizagem colaborativa.'
          }
        ]
      }
    ]
  },
  {
    title: 'Ciências Humanas',
    levels: [
      {
        bgColor: 'bg-[#FF563014]',
        level: 'Crítico',
        measures: [
          {
            area: 'Rede (Secretaria de Educação)',
            description:
              'Emitir alerta às regionais sobre as escolas com desempenho crítico em Ciências Humanas e orientar intervenção pedagógica imediata. Verificar se há lacuna de formação docente na área e acionar programas de apoio. Monitorar evolução com periodicidade semanal.'
          },
          {
            area: 'GRE (Gerência Regional)',
            description: 'Acionar as escolas críticas para elaboração de plano de ação com prazo definido. Designar técnico pedagógico da regional para acompanhamento próximo dessas unidades. Registrar e reportar evolução à Secretaria.'
          },
          {
            area: 'Unidade Escolar',
            description:
              'Reorganizar o planejamento da área para priorizar os conteúdos com maior defasagem. Articular professores de Ciências Humanas para revisão coletiva das estratégias pedagógicas. Criar espaços de debate e discussão que aproximem os conteúdos da realidade dos alunos e aumentem o engajamento.'
          }
        ]
      },
      {
        bgColor: 'bg-[#FFAB0014]',
        level: 'Moderado',
        measures: [
          {
            area: 'Rede (Secretaria de Educação)',
            description: 'Analisar se o desempenho mediano em Ciências Humanas é generalizado ou concentrado em determinadas regionais e ajustar o suporte de acordo. Disponibilizar orientações sobre estratégias ativas de aprendizagem para a área.'
          },
          {
            area: 'GRE (Gerência Regional)',
            description: 'Promover troca de experiências entre escolas da regional com diferentes níveis de desempenho. Verificar se os professores estão utilizando os recursos da plataforma e apoiar a diversificação das estratégias.'
          },
          {
            area: 'Unidade Escolar',
            description: 'Diversificar as estratégias de ensino para aumentar o engajamento dos alunos com os conteúdos de Ciências Humanas. Utilizar os dados dos quizzes para identificar os temas com maior dificuldade e concentrar revisões neles.'
          }
        ]
      },
      {
        bgColor: 'bg-[#22C55E14]',
        level: 'Preventivo',
        measures: [
          {
            area: 'Rede (Secretaria de Educação)',
            description: 'Manter o monitoramento e reconhecer publicamente as escolas com bom desempenho em Ciências Humanas como incentivo para a rede.'
          },
          {
            area: 'GRE (Gerência Regional)',
            description: 'Estimular que as escolas com bom desempenho na área compartilhem suas estratégias com as demais da regional.'
          },
          {
            area: 'Unidade Escolar',
            description: 'Sustentar as práticas que têm gerado bons resultados e incentivar a participação contínua dos alunos nas atividades da plataforma. Utilizar o fórum e os desafios como espaços de aprofundamento e não apenas de revisão.'
          }
        ]
      }
    ]
  },
  {
    title: 'Linguagens e suas Tecnologias',
    levels: [
      {
        bgColor: 'bg-[#FF563014]',
        level: 'Crítico',
        measures: [
          {
            area: 'Rede (Secretaria de Educação)',
            description:
              ' Identificar as escolas com desempenho crítico em Linguagens e acionar suporte técnico emergencial via regionais. Verificar se a defasagem está relacionada a dificuldades de leitura e interpretação de texto — competências que atravessam todas as áreas — e tratar com prioridade transversal.'
          },
          {
            area: 'GRE (Gerência Regional)',
            description: 'Apoiar as escolas críticas na reorganização do planejamento da área e no uso mais efetivo da plataforma. Promover alinhamento entre os professores de Linguagens das escolas em pior situação para troca de estratégias.'
          },
          {
            area: 'Unidade Escolar',
            description:
              ' Mapear os alunos com maior dificuldade em leitura e interpretação e criar grupos de reforço com regularidade. Articular professores de todas as áreas para reforçar competências leitoras de forma transversal. Acionar monitorias e estimular o uso do guia de estudos para revisão dos conteúdos com maior índice de erro.'
          }
        ]
      },
      {
        bgColor: 'bg-[#FFAB0014]',
        level: 'Moderado',
        measures: [
          {
            area: 'Rede (Secretaria de Educação)',
            description:
              'Orientar as regionais a verificar se as escolas com desempenho mediano em Linguagens estão utilizando plenamente os recursos disponíveis na plataforma. Disponibilizar materiais de apoio com foco em produção textual e interpretação.'
          },
          {
            area: 'GRE (Gerência Regional)',
            description: 'Acompanhar as escolas da regional e verificar a regularidade das atividades de Linguagens na plataforma. Sugerir práticas de leitura contextualizada que conectem o conteúdo à realidade dos alunos.'
          },
          {
            area: 'Unidade Escolar',
            description:
              'Revisar as estratégias de ensino de leitura e escrita à luz dos dados de desempenho. Estimular o uso do fórum como espaço de produção e troca de texto entre alunos. Propor atividades de correção de redações com feedback individualizado.'
          }
        ]
      },
      {
        bgColor: 'bg-[#22C55E14]',
        level: 'Preventivo',
        measures: [
          {
            area: 'Rede (Secretaria de Educação)',
            description: 'Documentar e disseminar as práticas das escolas com bom desempenho em Linguagens, especialmente as relacionadas ao uso de monitorias e fórum — que tendem a ser mais eficazes nessa área.'
          },
          {
            area: 'GRE (Gerência Regional)',
            description: 'Estimular que as escolas de melhor desempenho em Linguagens da regional sirvam como referência para as demais, promovendo visitas e trocas entre coordenadores.'
          },
          {
            area: 'Unidade Escolar',
            description: 'Manter a cadência das atividades e celebrar os avanços dos alunos para sustentar a motivação. Explorar os desafios da semana e os duelos como oportunidades de prática de linguagem de forma lúdica e competitiva.'
          }
        ]
      }
    ]
  }
];

export default function InterventionProposal({ data, studentsLevel }) {
  const [selectedTab, setSelectedTab] = useState('Crítico');
  const [items, setItems] = useState([]);
  const [studentsWithPreventiveLevel, setStudentsWithPreventiveLevel] = useState([]);

  const areaMap = {
    Matemática: 'matematica',
    'Ciências da Natureza': 'ciencias_natureza',
    'Ciências Humanas': 'ciencias_humanas',
    'Linguagens e suas Tecnologias': 'linguagens'
  };

  const iconMap = {
    Crítico: siren,
    Moderado: warning,
    Preventivo: check
  };

  useEffect(() => {
    if (!data?.length) {
      setItems([]);
      return;
    }

    const result = ranges
      .map(range => {
        const key = areaMap[range.title];

        const hasLevel = data.some(item => item[key]?.label === selectedTab);

        if (!hasLevel) return null;

        const levelData = range.levels.find(l => l.level === selectedTab);

        if (!levelData) return null;

        return {
          title: range.title,
          ...levelData
        };
      })
      .filter(Boolean);

    setItems(result);
  }, [data, selectedTab]);

  useEffect(() => {
    if (studentsLevel) {
      const preventiveStudents = data.filter(item => item.overall?.label === 'Preventivo').map(item => item.student_name);
      setStudentsWithPreventiveLevel(preventiveStudents);
    } else {
      setStudentsWithPreventiveLevel([]);
    }
  }, [studentsLevel, data]);

  return (
    <div className="report-widget">
      <div className="report-widget__header">
        <h3 className="report-widget__title underline">Proposta de Intervenção</h3>
      </div>

      <div className="report-widget__body">
        {/* Tabs */}
        <div className="w-fit p-1">
          <button
            onClick={() => setSelectedTab('Crítico')}
            className={`rounded-l-full px-4 py-1.5 text-sm transition ${selectedTab === 'Crítico' ? 'bg-primary text-white shadow' : 'bg-neutral-bright text-gray-500'}`}
          >
            Crítico
          </button>

          <button
            onClick={() => setSelectedTab('Moderado')}
            className={`px-4 py-1.5 text-sm transition ${selectedTab === 'Moderado' ? 'bg-primary text-white shadow' : 'bg-neutral-bright text-gray-500'}`}
          >
            Moderado
          </button>

          <button
            onClick={() => setSelectedTab('Preventivo')}
            className={`rounded-r-full px-4 py-1.5 text-sm transition ${selectedTab === 'Preventivo' ? 'bg-primary text-white shadow' : 'bg-neutral-bright text-gray-500'}`}
          >
            Preventivo
          </button>
        </div>

        {/* Conteúdo */}
        {items.length === 0 ? (
          <p className="mt-4 text-sm text-neutral">Nenhuma intervenção necessária para este nível.</p>
        ) : (
          <div className="mt-4 flex flex-col gap-4">
            {items.map(item => (
              <div
                key={item.title}
                className={`p-3 text-primary-dark ${item.bgColor} rounded-lg`}
              >
                <div className="mb-2 flex items-center gap-3">
                  <img
                    src={iconMap[selectedTab]}
                    alt="Icon"
                    className="h-4 w-4"
                  />
                  <span className="font-semibold">{item.title}</span>
                </div>

                {item.measures.map((measure, index) => (
                  <p
                    key={index}
                    className="ml-3 text-sm"
                  >
                    <b>{measure.area}:</b> {measure.description}
                  </p>
                ))}
              </div>
            ))}

            {selectedTab === 'Preventivo' && studentsWithPreventiveLevel.length > 0 && (
              <div className={`rounded-lg bg-[#00B8D914] p-3 text-primary-dark`}>
                <div className="flex items-center gap-3">
                  <img
                    src={books}
                    alt="Icon"
                    className="h-4 w-4"
                  />
                  <p className="text-sm">
                    <b>Sugestão de monitoramento:</b> Há {studentsWithPreventiveLevel.length} alunos que apresentam bom desempenho e estão aptos para monitorar outros alunos
                  </p>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
